module.exports = __webpack_public_path__ + "media/images/30px_halfstar-c5821b42168c07824c959e104c1838ffbe14b34d4bfdfe138c0e1595317e1c59.png";